const LIMIT = 100;

const CONTENT_TYPE_ALLOWLIST = {
    "Author": true,
    "City": true,
    "Classification": true,
    "Commodity": true,
    "Company": true,
    "Country": true,
    "Currency": true,
    "Dataarticle": true,
    "Event": true,
    "Feature": true,
    "Fund": true,
    "Index": true,
    "Interactive": true,
    "Location": true,
    "Organization": true,
    "Person": true,
    "Region": true,
    "Series": true,
    "Slideshow": true,
    "Story": true,
    "Topic": true,
    "Video": true,
    "Storythread": true,
};

const METADATA_QUERY_PARAMS_MAP = {
    deviceInfo: "metadata.paywall.device",
    referrerSource: "metadata.paywall.referrer",
    consent: "metadata.consent",
};

export default function makeUrl(params) {
    const {
        baseUrl,
    } = params;

    const queryString = makeQueryString(params);

    return queryString
        ? `${ baseUrl }?${ queryString }`
        : baseUrl;
}

export function getDeviceInfoString(params) {
    if (!params.deviceInfo) {
        return undefined;
    }

    return `${ params.deviceInfo.platform }|${ params.deviceInfo.OS }|${ params.deviceInfo.browserName }`;
}

function makeQueryString(params) {
    const currentResource = getCurrentResource(params);
    const deviceInfo = getDeviceInfoString(params);
    const paramsObject = Object.assign({},
        currentResource,
        { deviceInfo },
        { consent: params.personalizationAllowed },
        { referrerSource: params.referrerSource },
        { limit: params.limit !== null ? LIMIT : null },
        { ...params?.coordinatorQueryParams }
    );

    return makeQueryStringFromObject(paramsObject);
}

function getCurrentResource(params) {
    const {
        id,
        contentType,
    } = params;

    if (id !== undefined && Object.prototype.hasOwnProperty.call(CONTENT_TYPE_ALLOWLIST, contentType)) {
        const currentResource = `${ contentType }|${ id }`;

        return { currentResource };
    }
}

function makeQueryStringFromObject(obj) {
    return Object.keys(obj).filter((key) => {
        const value = obj[key];
        const isEmptyValue = value === undefined || value === null || value === "";

        return !isEmptyValue;
    })
        .map((key) => {
            const value = obj[key];
            const encodedKey = METADATA_QUERY_PARAMS_MAP[key] === undefined
                ? encodeURIComponent(key)
                : encodeURIComponent(METADATA_QUERY_PARAMS_MAP[key]);
            const encodedValue = encodeURIComponent(value);

            return `${ encodedKey }=${ encodedValue }`;
        })
        .join("&");
}
